import type { TaskListTemplateModel } from '@models/types'

import useTaskListTemplateSections from '@hooks/useTaskListTemplateSections'

import TaskListTemplateSection from './TaskListTemplateSection'

interface TaskListTemplateSectionsProps {
  taskListTemplate: TaskListTemplateModel,
}

const TaskListTemplateSections = (props: TaskListTemplateSectionsProps) => {
  const { taskListTemplate } = props

  const taskListTemplateSectionsPayload = useTaskListTemplateSections({
    filters: {
      task_list_template_id: taskListTemplate.id,
    },
  })

  const {
    filteredTaskListTemplateSections,
  } = taskListTemplateSectionsPayload

  return filteredTaskListTemplateSections.map(taskListTemplateSection => (
    <TaskListTemplateSection
      key={taskListTemplateSection.id}
      taskListTemplateSection={taskListTemplateSection}
    />
  ))
}

export default TaskListTemplateSections
